import { useI18n } from '@/hooks/use-i18n'
import { SupportedLanguages } from '@/i18n/config'

type GetLinkTitle = (platformTitle: string, combinations: string[]) => string

interface UseLinkListTitleProps {
  getLinkTitle: GetLinkTitle
}

const useLinkListTitle = (): UseLinkListTitleProps => {
  const { language } = useI18n()

  return {
    getLinkTitle: (platformTitle, combinations): string => {
      if (language.i18nCode === SupportedLanguages.enUS) {
        return [platformTitle, ...combinations].join(' ')
      }
      return `${platformTitle} ${combinations.join('')}`
    },
  }
}

export default useLinkListTitle
